import { RouterClient } from "../../../../clients/routerClient";
import { Logger } from "../../../../clients/logger";
import { WrapState } from "../types";

/**
 * Publishes out the wrap state to the system. Helper for consistent
 * logging and typescript
 * @param windowName Name of the window
 * @param state What state is the window in?
 */
export const publishWrapState = (windowName: string, state: WrapState) => {
	Logger.system.log("COMPONENT LIFECYCLE: STATE CHANGE: ", state, windowName);
	RouterClient.publish(`Finsemble.Component.State.${windowName}`, {
		state: state,
	});
};
